module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSI1NiIgdmlld0JveD0iMCAwIDEgNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjAuNzUwMDAxIiB5PSIwLjI0OTk5OSIgd2lkdGg9IjU1LjUiIGhlaWdodD0iMC40OTk5OTkiIHRyYW5zZm9ybT0icm90YXRlKDkwIDAuNzUwMDAxIDAuMjQ5OTk5KSIgc3Ryb2tlPSIjRTdFN0U3IiBzdHJva2Utd2lkdGg9IjAuNDk5OTk5Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Vertical.svg
// module id = 313
// module chunks = 1